export default __webpack_public_path__ + "static/media/three.c72d6d68.jpeg";